export const CONFIG = {
  appName: "Starcade"
}